export const eventPromise = async (
  el: HTMLElement,
  event: keyof HTMLElementEventMap,
  duration?: number,
  verifyTarget = false,
): Promise<void> => {
  const promise = new Promise<void>((resolve) => {
    const listener = (e: Event) => {
      if (verifyTarget && e.target !== e.currentTarget) {
        return;
      }

      resolve();
      el.removeEventListener(event, listener);
    };

    el.addEventListener(event, listener);
  });

  return Promise.race([
    promise,
    durationPromise(duration)
  ]);
}

export const durationPromise = (duration = 500) => {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, duration);
  })
}
